export const getCriterionChipColors = (theme, isActive) => {
  if (isActive) return { backgroundColor: theme.colors.primary.surface, color: theme.colors.primary.onSurface }

  return { backgroundColor: theme.colors.disabled.surface, color: theme.colors.disabled.content }
}
